import type { TrackingFn } from '@change-corgi/core/react/tracking';

import { getNavigatorShareInterface } from 'src/app/shared/share/utils';

import { trackShareFailure, trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
		failure: string;
	};
};

/**
 * @deprecated Use `shareNativeExtended` instead.
 */
export async function shareNative(
	url: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): Promise<boolean> {
	const navigator = getNavigatorShareInterface();

	if (!navigator || !navigator.canShare({ url })) {
		return false;
	}

	try {
		await navigator.share({ url });
		trackShareSuccess(trackingEvents.success, trackingData, track);
		return true;
	} catch (e) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const error = e as Error;
		if (error.name === 'AbortError') {
			return false;
		}
		trackShareFailure(
			trackingEvents.failure,
			{
				...trackingData,
				errorName: error.name,
				errorMessage: error.message,
			},
			track,
		);
		return false;
	}
}
